module.exports = __webpack_public_path__ + "static/media/17_Bob_O@3x.1ae85d89.jpg";